import React, {Component} from 'react';
import SliderForm from './form';
import {addSliderItem} from '../../modules/Api';
import {normalizer} from './pipeline';
import {notification} from 'antd';
import history from '../../modules/History';

class AddSlider extends Component {
    constructor() {
        super();
        this.state = {
            data: {},
            submitted: false
        }
    }

    get params() {
        return this.props.location.search
            .replace('?', '')
            .split('&')
            .reduce((params, q) => {
                const [key, value] = q.split('=');
                params[key] = value;
                return params;
            }, {});
    }

    submit(values) {
        if(this.state.submitted){
            return;
        }
        this.setState({submitted: true});
        const formData = normalizer({...values, ...this.params});
        addSliderItem(formData, () => {
            notification.open({
                message: `اسلایدر اضافه شد.!`,
                description: `در صورت نیاز میتوانید با درگ دراپ کردن جای اسلایدر را تغییر دهید.`
            });
            this.setState({submitted: false});
            const url = this.props.appSlider ? '/app-sliders' : '/sliders';
            history.item.push(`${url}${this.props.location.search}`);
        });
    }
    render() {
        return (
            <div><SliderForm  initialData={this.state} appSlider={this.props.appSlider} submit={this.submit.bind(this)} submitted={this.state.submitted}/></div>
        );
    }
}
export default AddSlider;



// WEBPACK FOOTER //
// ./src/containers/Sliders/add.js